import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, updateData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { Tooltip } from '@mui/material';
import {
    Checkbox, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';
import Modal from '@mui/material/Modal';
import { Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useLocation, Link } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


function CreditorDebitorReport() {
    const { isAuthenticated, companyId, branchId, permissions, companyName, token, username, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        // Token is not expired, fetch data
        fetchTableData();

    }, [isAuthenticated, companyId, branchId, permissions, token, logout]);

    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]); // Default to today's date
    const [isFocused, setIsFocused] = useState(false);

    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const hasDeleteMasterPermission = permissions.includes('Delete Transaction');
    const hasReadReportPermission = permissions.includes('Read Reports');

    // Function to format date as dd/mm/yyyy
    const getCurrentDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0'); // Add leading zero
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Add leading zero, months are 0-indexed
        const year = today.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (event) => {
        setToDate(event.target.value); // Ensure `toDate` is updated
    };

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const [totalcls, setTotalcls] = useState(0);

    useEffect(() => {
        let totalcls = 0;

        data.forEach(item => {
            totalcls += item.amount;

        });
        setTotalcls(totalcls);
    }, [data]);

    const [debitororcreditorType, setdebitororcreditor] = useState("1");
    const handlesetdebitororcreditorTypeChange = (event) => {
        setdebitororcreditor(event.target.value);
    };

    const [loading, setLoading] = useState(false);


    const fetchTableData = async () => {
        if (!toDate) {
            console.error('To Date is required!');
            return;
        }

        if (hasReadReportPermission) {
            setData([]);
            setLoading(true);
            try {
                const url = `/${toDate}/${companyId}/${companyId}/${companyId}/${companyId}/${companyId}/${debitororcreditorType}`;
                //console.log('Constructed URL:', url);
                const response = await fetchData('ReportApi', url, token);
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Stock Details:', error);
            } finally {
                setLoading(false);
            }
        }
    };


    // const handleExportExcel = async () => {
    //     const workbook = new ExcelJS.Workbook();
    //     const worksheet = workbook.addWorksheet(
    //         debitororcreditorType === "1" ? "Creditors List" : "Debtors List"
    //     );

    //     const now = new Date();
    //     const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
    //     const title = `${companyName} - ${debitororcreditorType === "1" ? "Creditors List" : "Debtors List"}:  To: ${formatDate(toDate)} | Generated On: ${formattedDateTime} By: ${username}`;

    //     // 🟦 Title Row (merged across columns A-C)
    //     worksheet.mergeCells('A1:C1');
    //     const titleCell = worksheet.getCell('A1');
    //     titleCell.value = title;
    //     titleCell.font = { bold: true, size: 9 };
    //     titleCell.alignment = { vertical: 'middle', horizontal: 'center' };
    //     titleCell.fill = {
    //         type: 'pattern',
    //         pattern: 'solid',
    //         fgColor: { argb: 'FFDDEEFF' }
    //     };

    //     // 🟩 Header Row
    //     const headerRow = worksheet.addRow(['Name', 'Contact No', 'Amount']);
    //     headerRow.eachCell((cell) => {
    //         cell.font = { bold: true };
    //         cell.alignment = { horizontal: 'center' };
    //         cell.fill = {
    //             type: 'pattern',
    //             pattern: 'solid',
    //             fgColor: { argb: 'FFCCE5FF' }, // light blue
    //         };
    //         cell.border = {
    //             top: { style: 'thin' },
    //             left: { style: 'thin' },
    //             bottom: { style: 'thin' },
    //             right: { style: 'thin' },
    //         };
    //     });

    //     // 🟨 Add Data Rows (with borders + alignment + special Total highlight)
    //     filteredData.forEach((rowData) => {
    //         const row = worksheet.addRow([
    //             rowData.name,
    //             rowData.Contactno,
    //             parseFloat(rowData.amount.toFixed(2))
    //         ]);

    //         row.eachCell((cell, colNumber) => {
    //             cell.border = {
    //                 top: { style: 'thin' },
    //                 left: { style: 'thin' },
    //                 bottom: { style: 'thin' },
    //                 right: { style: 'thin' },
    //             };

    //             // 🔹 Right align only Amount column
    //             if (colNumber === 3) {
    //                 cell.alignment = { horizontal: 'right' };
    //             }

    //             // 🔹 If this is the "Total" row, highlight entire row
    //             if (rowData.name?.toLowerCase() === "total") {
    //                 cell.font = { bold: true };
    //                 cell.fill = {
    //                     type: 'pattern',
    //                     pattern: 'solid',
    //                     fgColor: { argb: 'FFFFE699' }, // light yellow
    //                 };
    //             }
    //         });
    //     });

    //     // 📝 Adjust Column Widths
    //     worksheet.columns = [
    //         { key: 'name', width: 30 },
    //         { key: 'contact', width: 25 },
    //         { key: 'amount', width: 15 },
    //     ];

    //     // 📁 Generate file
    //     const buffer = await workbook.xlsx.writeBuffer();
    //     const fileName = `$${debitororcreditorType === "1" ? "Creditors List" : "Debtors List"}_${formatDate(toDate).replace(/\//g, '-')}.xlsx`;
    //     saveAs(new Blob([buffer]), fileName);
    // };
    const handleExportExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(
            debitororcreditorType === "1" ? "Creditors List" : "Debtors List"
        );

        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
        const title = `${companyName} - ${debitororcreditorType === "1" ? "Creditors List" : "Debtors List"}:  To: ${formatDate(toDate)} | Generated On: ${formattedDateTime} By: ${username}`;

        // 🟦 Title Row (merged across columns A-C)
        worksheet.mergeCells('A1:C1');
        const titleCell = worksheet.getCell('A1');
        titleCell.value = title;
        titleCell.font = { bold: true, size: 9 };
        titleCell.alignment = { vertical: 'middle', horizontal: 'center' };
        titleCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFDDEEFF' }
        };

        // 🟩 Header Row
        const headerRow = worksheet.addRow(['Name', 'Contact No', 'Amount']);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFCCE5FF' }, // light blue
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        });

        // 🟨 Add Data Rows (with borders + alignment + special Total highlight)
        filteredData.forEach((rowData) => {
            const row = worksheet.addRow([
                rowData.name,
                rowData.Contactno,
                parseFloat(rowData.amount.toFixed(2))
            ]);

            row.eachCell((cell, colNumber) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };

                // 🔹 Right align only Amount column
                if (colNumber === 3) {
                    cell.alignment = { horizontal: 'right' };
                }

                // 🔹 If this is the "Total" row, highlight entire row
                if (rowData.name?.toLowerCase() === "total") {
                    cell.font = { bold: true };
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFFFE699' }, // light yellow
                    };
                }
            });
        });


        // 📝 Adjust Column Widths
        worksheet.columns = [
            { key: 'name', width: 30 },
            { key: 'contact', width: 25 },
            { key: 'amount', width: 15 },
        ];

        // 📁 Generate file
        const buffer = await workbook.xlsx.writeBuffer();
        const fileName = `$${debitororcreditorType === "1" ? "Creditors List" : "Debtors List"}_${formatDate(toDate).replace(/\//g, '-')}.xlsx`;
        saveAs(new Blob([buffer]), fileName);
    };


    return (


        <div className="w-full mx-auto" style={{ width: '95%', marginTop: '-10px', fontFamily: 'Segoe UI, sans-serif' }}>

            {/* Header Section */}
            <div className="w-full mb-4 flex justify-between items-center">
                <div
                    style={{
                        background: "whitesmoke",
                        color: "black",
                        padding: "5px 10px",
                        borderTopLeftRadius: "6px",
                        borderTopRightRadius: "6px",
                        fontSize: "12px",
                        fontWeight: "bold",
                        letterSpacing: "0.5px",
                        marginTop: '-30px',
                        height: '30px'
                    }}
                >
                    {debitororcreditorType === "1" ? "CREDITORS LIST" : "DEBITORS LIST"}
                </div>
                {/* Filter Row */}
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        gap: '15px',
                        padding: '10px 20px',
                        background: '#fff'
                    }}
                >
                    {/* To Date */}
                    <div style={{ maxWidth: '150px' }}>
                        <label
                            className="block tracking-wide text-black text-xs mb-1"
                            htmlFor="toDate"
                        >
                            To Date
                        </label>
                        <input
                            id="toDate"
                            className="shadow appearance-none border rounded w-full py-1 px-2 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            type="date"
                            value={toDate}
                            onChange={handleToDateChange}
                            style={{ fontSize: '12.5px', width: '100%' }}
                        />
                    </div>

                    {/* Radio Buttons */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <label>
                            <input
                                type="radio"
                                name="debitororcreditorType"
                                value="1"
                                checked={debitororcreditorType === "1"}
                                onChange={handlesetdebitororcreditorTypeChange}
                            />
                            <span style={{ color: 'blue', fontSize: '12px', marginLeft: '5px' }}>
                                Creditors
                            </span>
                        </label>
                        <label>
                            <input
                                type="radio"
                                name="debitororcreditorType"
                                value="2"
                                checked={debitororcreditorType === "2"}
                                onChange={handlesetdebitororcreditorTypeChange}
                            />
                            <span style={{ color: 'brown', fontSize: '12px', marginLeft: '5px' }}>
                                Debitors
                            </span>
                        </label>
                    </div>

                    {/* Buttons */}
                    <Button
                        onClick={fetchTableData}
                        style={{
                            background: "#2f4050",
                            color: "white",
                            borderRadius: "4px",
                            padding: "5px 12px",
                            fontSize: "13px",
                            fontWeight: "bold",
                            height: "28px",
                        }}
                    >
                        Refresh
                    </Button>

                    {/* Excel */}
                    <Button
                        onClick={handleExportExcel}
                        style={{
                            background: "#00695c",
                            color: "white",
                            borderRadius: "4px",
                            padding: "5px 12px",
                            fontSize: "13px",
                            fontWeight: "bold",
                            height: "28px",
                        }}
                    >
                        Excel
                    </Button>
                </div>

            </div>
            <div className="watermark" style={{ position: 'absolute', bottom: '10px', right: '20px' }}>
                <CopyrightIcon />
                <b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>
            {/* <div
                className="w-full mb-5 flex"
                style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '7px' }}
            >
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#484743', width: '2500px' }}>
                            <TableRow sx={{ whiteSpace: 'nowrap' }}>
                                {[
                                    'Name',
                                    'Contact',
                                    'Amount',
                                ].map((header) => (
                                    <TableCell
                                        key={header}
                                        sx={{
                                            borderBottom: '1px solid #F5F5F5',
                                            fontWeight: 'bolder',
                                            fontSize: '11px',
                                            padding: '3px',
                                            color: 'whitesmoke',
                                            backgroundColor: '#484743',
                                            textTransform: 'uppercase',
                                        }}
                                    >
                                        {header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead> */}
            <div className='w-full mb-5 flex' style={{ maxHeight: '500px', overflowY: 'auto', marginTop: '10px' }}>
                <TableContainer component={Paper} sx={{ boxShadow: '0 4px 10px rgba(0,0,0,0.05)' }}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#EDF1EF' }}>
                            <TableRow>
                                {['Name', 'Contact', 'Amount'].map((col) => (
                                    <TableCell
                                        key={col}
                                        sx={{
                                            color: 'black',
                                            fontWeight: 'bold',
                                            fontSize: '11px',
                                            textTransform: 'uppercase',
                                            padding: '3px',
                                            borderBottom: 'none',
                                            backgroundColor: '#edf1efff'
                                        }}
                                        align={col === 'Amount' ? 'right' : 'left'} // ✅ Proper alignment
                                    >
                                        {col}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredData.map((data, index) => {

                                return (
                                    <TableRow
                                        key={data.id}
                                        sx={{
                                            backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff',
                                            '&:hover': { backgroundColor: '#e1f5fe' },
                                        }}
                                    >
                                        <TableCell sx={{ fontSize: '13px', padding: '6px' }}>
                                            {data.name}
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                fontSize: '13px',
                                                padding: '6px',

                                            }}
                                        >
                                            {data.Contactno}
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                fontSize: '13px',
                                                padding: '6px',
                                                textAlign: 'right',

                                            }}
                                        >
                                            {data.amount}
                                        </TableCell>

                                    </TableRow>
                                );
                            })}
                        </TableBody>

                        {/* <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {filteredData.map((data, index) => {
                                const isTotalRow = data.name === "Total";
                                return (
                                    <TableRow
                                        key={data.id}
                                        className="highlighted-row"
                                        sx={{
                                            //padding: '7px',
                                            height: '42px',
                                            backgroundColor: isTotalRow ? '#f0f0f0' : 'white',
                                            textTransform: 'capitalize',
                                            '&:last-child td, &:last-child th': { border: 0 },
                                        }}
                                    >
                                        {[data.name, data.Contactno, data.amount].map((value, i) => (
                                            <TableCell
                                                key={i}
                                                sx={{
                                                    borderBottom: '1px solid #ddd',
                                                    color: isTotalRow ? 'darkred' : 'black',
                                                    fontWeight: isTotalRow ? 'bold' : 'bolder',
                                                    padding: '3px',
                                                    fontSize: '13px',
                                                    textAlign: i >= 3 ? 'center' : 'left',
                                                }}
                                            >
                                                {value}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                );
                            })}
                        </TableBody> */}

                    </Table>
                </TableContainer>

            </div>

        </div>
    );
}

export default CreditorDebitorReport;